<template>
   <vs-popup class="mobile-order-popup-root" title="Mobil ve Online Siparişler" fullscreen :active.sync="orderListIsActiveLocal">
    <printer v-if="printeractive" ref="printer"
             :orderDetail="orderDetail"
             :orderEntries="orderDetail.cartEntries"
             :totalPrice="orderDetail.totalPrice"
             :totalDiscountPrice="orderDetail.totalCampaignDiscountAmount"
             :currentDateTime="currentDate"
             :activePersonal="''"/>
    <vs-row v-if="!isMobileOrderUi" class="mobile-order-toolbar mobile-order-toolbar--desktop">
      <vs-col vs-w="6">
        <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-refresh-cw" @click="getOrder()">Manuel Yenile</vs-button>
      </vs-col>
      <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end">
        <vs-button type="gradient" color="success" @click="readQr()">QR ile Teslim Et</vs-button>
      </vs-col>
    </vs-row>
    <vs-row v-else class="mobile-order-toolbar mobile-order-toolbar--mobile">
      <vs-col vs-w="12" class="mobile-order-toolbar-btn-wrap">
        <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-refresh-cw" class="mobile-order-toolbar-btn" @click="getOrder()">Manuel Yenile</vs-button>
      </vs-col>
      <vs-col vs-w="12" class="mobile-order-toolbar-btn-wrap">
        <vs-button type="gradient" color="success" class="mobile-order-toolbar-btn" @click="readQr()">QR ile Teslim Et</vs-button>
      </vs-col>
    </vs-row>

    <div v-if="!isMobileOrderUi" class="kanban-board">
      <div class="kanban-column">
        <h1>Bekliyor</h1>
        <vs-card v-for="order in orders" :key="getOrderKey(order)" v-if="order.orderStatus === 0">
          <!-- Integration Orders (use MobileOrderCard) -->
          <template v-if="order.isIntegrationOrder">
            <mobile-order-card
              :order="order"
              @show-PopupDetail2="showPopupDetail2"
              @show-popup="showPopup"
              @dismiss-from-board="onDismissIntegrationOrderFromBoardRequest"
              :remainingTime="remainingTime(order.tableId)"
              :nextTitle="'Siparişi hazırlanıyora çek'"
              :nextStatus="1"
            />
          </template>

          <!-- Mobile Orders (original layout) -->
          <template v-else>
            <div @click="showPopupDetail(order)" slot="header">
              <vs-row vs-align="flex-start">
                <vs-col vs-justify="center" vs-align="center" vs-w="5">Id</vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="4">Teslimat</vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="3">Kalan Süre</vs-col>
              </vs-row>
              <vs-row vs-align="flex-start">
                <vs-col vs-w="5"><h3>{{ order.id }}</h3></vs-col>
                <vs-col vs-w="4"><h3>{{order.deliveryDateString}}</h3></vs-col>
                <vs-col vs-w="3"><h3><div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3></vs-col>
              </vs-row>
            </div>
            <div>
              <vs-row vs-align="flex-end">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi iptal et" type="gradient" color="danger" icon-pack="feather" icon="icon-trash" @click="showPopup(order.id, null, -1)"></vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi hazırlanıyora çek" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, null, 1)"></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </template>
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>Hazırlanıyor</h1>
        <vs-card v-for="order in orders" :key="getOrderKey(order)" v-if="order.orderStatus === 1">
          <!-- Integration Orders -->
          <template v-if="order.isIntegrationOrder">
            <mobile-order-card
              :order="order"
              @show-PopupDetail2="showPopupDetail2"
              @show-popup="showPopup"
              @dismiss-from-board="onDismissIntegrationOrderFromBoardRequest"
              :remainingTime="remainingTime(order.tableId)"
              :nextTitle="'Siparişi hazırlandıya çek'"
              :nextStatus="2"
            />
          </template>

          <!-- Mobile Orders -->
          <template v-else>
            <div @click="showPopupDetail(order)" slot="header">
              <vs-row vs-align="flex-start">
                <vs-col vs-justify="center" vs-align="center" vs-w="5">Id</vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="4">Teslimat</vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="3">Kalan Süre</vs-col>
              </vs-row>
              <vs-row vs-align="flex-start">
                <vs-col vs-w="5"><h3>{{ order.id }}</h3></vs-col>
                <vs-col vs-w="4"><h3>{{order.deliveryDateString}}</h3></vs-col>
                <vs-col vs-w="3"><h3><div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3></vs-col>
              </vs-row>
            </div>
            <div>
              <vs-row vs-align="flex-end">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi beklemeye geri çek" type="gradient" color="danger" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(order.id, null, 0)"></vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi tamamlandıya çek" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, null, 2)"></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </template>
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>Hazır</h1>
        <vs-card v-for="order in orders" :key="getOrderKey(order)" v-if="order.orderStatus === 2">
          <!-- Integration Orders -->
          <template v-if="order.isIntegrationOrder">
            <mobile-order-card
              :order="order"
              @show-PopupDetail2="showPopupDetail2"
              @show-popup="showPopup"
              @dismiss-from-board="onDismissIntegrationOrderFromBoardRequest"
              :remainingTime="remainingTime(order.tableId)"
              :nextTitle="'Siparişi Kuryeye Teslim Et'"
              :nextStatus="4"
            />
          </template>

          <!-- Mobile Orders -->
          <template v-else>
            <div @click="showPopupDetail(order)" slot="header">
              <vs-row vs-align="flex-start">
                <vs-col vs-justify="center" vs-align="center" vs-w="5">Id</vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="4">Teslimat</vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="3">Kalan Süre</vs-col>
              </vs-row>
              <vs-row vs-align="flex-start">
                <vs-col vs-w="5"><h3>{{ order.id }}</h3></vs-col>
                <vs-col vs-w="4"><h3>{{order.deliveryDateString}}</h3></vs-col>
                <vs-col vs-w="3"><h3><div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3></vs-col>
              </vs-row>
            </div>
            <div>
              <vs-row vs-align="flex-end">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi hazırlanıyora geri çek" type="gradient" color="danger" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(order.id, null, 1)"></vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi Teslim Et" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, null, 3)"></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </template>
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>Kuryede</h1>
        <vs-card v-for="order in orders" :key="getOrderKey(order)" v-if="order.orderStatus === 4">
          <!-- Only Integration Orders can be in courier status -->
          <mobile-order-card
            :order="order"
            @show-PopupDetail2="showPopupDetail2"
            @show-popup="showPopup"
            @dismiss-from-board="onDismissIntegrationOrderFromBoardRequest"
            :remainingTime="remainingTime(order.tableId)"
            :nextTitle="'Siparişi Teslim Et'"
            :nextStatus="3"
          />
        </vs-card>
      </div>

      <div class="kanban-column">
        <div class="kanban-column-title-row">
          <h1>Tamamlandı</h1>
          <vs-button
            v-if="completedIntegrationOrdersCount > 0"
            size="small"
            type="filled"
            color="dark"
            icon-pack="feather"
            icon="icon-layers"
            title="Tüm tamamlanan entegrasyon siparişlerini panodan kaldır"
            @click="onDismissAllCompletedIntegrationRequest"
          >Toplu temizle</vs-button>
        </div>
        <vs-card v-for="order in orders" :key="getOrderKey(order)" v-if="order.orderStatus === 3">
          <!-- Integration Orders -->
          <template v-if="order.isIntegrationOrder">
            <mobile-order-card
              :order="order"
              @show-PopupDetail2="showPopupDetail2"
              @show-popup="showPopup"
              @dismiss-from-board="onDismissIntegrationOrderFromBoardRequest"
              :remainingTime="remainingTime(order.tableId)"
            />
          </template>

          <!-- Mobile Orders (Tamamlandı — dikey özet) -->
          <template v-else>
            <div @click="showPopupDetail(order)" slot="header" class="mobile-order-native-completed-summary">
              <div class="mobile-order-native-line">
                <span class="mobile-order-native-label">Id</span>
                <span class="mobile-order-native-value">{{ order.id }}</span>
              </div>
              <div class="mobile-order-native-line">
                <span class="mobile-order-native-label">Teslimat</span>
                <span class="mobile-order-native-value">{{ order.deliveryDateString }}</span>
              </div>
            </div>
            <div>
              <vs-row vs-align="flex-end">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi hazırlanıyora geri çek" type="gradient" color="warning" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(order.id, null, 1)"></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </template>
        </vs-card>
      </div>

      <div class="kanban-column">
        <h1>İptal Edildi</h1>
        <vs-card v-for="order in orders" :key="getOrderKey(order)" v-if="order.orderStatus === -1">
          <!-- Integration Orders -->
          <template v-if="order.isIntegrationOrder">
            <mobile-order-card
              :order="order"
              @show-PopupDetail2="showPopupDetail2"
              @show-popup="showPopup"
              @dismiss-from-board="onDismissIntegrationOrderFromBoardRequest"
              :remainingTime="remainingTime(order.tableId)"
            />
          </template>

          <!-- Mobile Orders -->
          <template v-else>
            <div @click="showPopupDetail(order)" slot="header">
              <vs-row vs-align="flex-start">
                <vs-col vs-justify="center" vs-align="center" vs-w="5">Id</vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="4">Teslimat</vs-col>
                <vs-col vs-justify="center" vs-align="center" vs-w="3">Durum</vs-col>
              </vs-row>
              <vs-row vs-align="flex-start">
                <vs-col vs-w="5"><h3>{{ order.id }}</h3></vs-col>
                <vs-col vs-w="4"><h3>{{order.deliveryDateString}}</h3></vs-col>
                <vs-col vs-w="3"><h3 style="color: red;">İptal</h3></vs-col>
              </vs-row>
            </div>
            <div>
              <vs-row vs-align="flex-end">
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                  <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                </vs-col>
              </vs-row>
            </div>
          </template>
        </vs-card>
      </div>
    </div>

    <vs-collapse
      v-else
      class="mobile-order-accordion w-full"
      type="margin"
      accordion
    >
      <vs-collapse-item
        v-for="col in orderBoardColumns"
        :key="'mob-ord-' + col.status"
        :open="col.status === 0"
        class="mobile-order-accordion-item"
      >
        <div slot="header" class="mobile-order-accordion-header">
          <span class="mobile-order-accordion-title">{{ col.title }}</span>
          <span class="mobile-order-accordion-count">{{ col.orders.length }}</span>
        </div>
        <div class="mobile-order-accordion-body">
          <div
            v-if="col.status === 3 && integrationCompletedCountForColumn(col) > 0"
            class="mobile-order-bulk-dismiss-wrap"
          >
            <vs-button
              size="small"
              type="filled"
              color="dark"
              icon-pack="feather"
              icon="icon-layers"
              class="mobile-order-bulk-dismiss-btn"
              @click.stop="onDismissAllCompletedIntegrationRequest"
            >Tamamlananları panodan kaldır</vs-button>
          </div>
          <vs-card
            v-for="order in col.orders"
            :key="getOrderKey(order)"
            class="mobile-order-accordion-card"
          >
            <template v-if="order.isIntegrationOrder">
              <mobile-order-card
                :order="order"
                @show-PopupDetail2="showPopupDetail2"
                @show-popup="showPopup"
                @dismiss-from-board="onDismissIntegrationOrderFromBoardRequest"
                :remainingTime="remainingTime(order.tableId)"
                :nextTitle="col.integrationNextTitle"
                :nextStatus="col.integrationNextStatus"
              />
            </template>
            <template v-else-if="col.status === 0">
              <div @click="showPopupDetail(order)" slot="header">
                <vs-row vs-align="flex-start">
                  <vs-col vs-justify="center" vs-align="center" vs-w="5">Id</vs-col>
                  <vs-col vs-justify="center" vs-align="center" vs-w="4">Teslimat</vs-col>
                  <vs-col vs-justify="center" vs-align="center" vs-w="3">Kalan Süre</vs-col>
                </vs-row>
                <vs-row vs-align="flex-start">
                  <vs-col vs-w="5"><h3>{{ order.id }}</h3></vs-col>
                  <vs-col vs-w="4"><h3>{{order.deliveryDateString}}</h3></vs-col>
                  <vs-col vs-w="3"><h3><div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3></vs-col>
                </vs-row>
              </div>
              <div>
                <vs-row vs-align="flex-end">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi iptal et" type="gradient" color="danger" icon-pack="feather" icon="icon-trash" @click="showPopup(order.id, null, -1)"></vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi hazırlanıyora çek" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, null, 1)"></vs-button>
                  </vs-col>
                </vs-row>
              </div>
            </template>
            <template v-else-if="col.status === 1">
              <div @click="showPopupDetail(order)" slot="header">
                <vs-row vs-align="flex-start">
                  <vs-col vs-justify="center" vs-align="center" vs-w="5">Id</vs-col>
                  <vs-col vs-justify="center" vs-align="center" vs-w="4">Teslimat</vs-col>
                  <vs-col vs-justify="center" vs-align="center" vs-w="3">Kalan Süre</vs-col>
                </vs-row>
                <vs-row vs-align="flex-start">
                  <vs-col vs-w="5"><h3>{{ order.id }}</h3></vs-col>
                  <vs-col vs-w="4"><h3>{{order.deliveryDateString}}</h3></vs-col>
                  <vs-col vs-w="3"><h3><div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3></vs-col>
                </vs-row>
              </div>
              <div>
                <vs-row vs-align="flex-end">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi beklemeye geri çek" type="gradient" color="danger" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(order.id, null, 0)"></vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi tamamlandıya çek" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, null, 2)"></vs-button>
                  </vs-col>
                </vs-row>
              </div>
            </template>
            <template v-else-if="col.status === 2">
              <div @click="showPopupDetail(order)" slot="header">
                <vs-row vs-align="flex-start">
                  <vs-col vs-justify="center" vs-align="center" vs-w="5">Id</vs-col>
                  <vs-col vs-justify="center" vs-align="center" vs-w="4">Teslimat</vs-col>
                  <vs-col vs-justify="center" vs-align="center" vs-w="3">Kalan Süre</vs-col>
                </vs-row>
                <vs-row vs-align="flex-start">
                  <vs-col vs-w="5"><h3>{{ order.id }}</h3></vs-col>
                  <vs-col vs-w="4"><h3>{{order.deliveryDateString}}</h3></vs-col>
                  <vs-col vs-w="3"><h3><div :class="{ 'warning': order.tableId <= 120 }">{{remainingTime(order.tableId)}}</div></h3></vs-col>
                </vs-row>
              </div>
              <div>
                <vs-row vs-align="flex-end">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi hazırlanıyora geri çek" type="gradient" color="danger" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(order.id, null, 1)"></vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi Teslim Et" type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(order.id, null, 3)"></vs-button>
                  </vs-col>
                </vs-row>
              </div>
            </template>
            <template v-else-if="col.status === 3">
              <div @click="showPopupDetail(order)" slot="header" class="mobile-order-native-completed-summary">
                <div class="mobile-order-native-line">
                  <span class="mobile-order-native-label">Id</span>
                  <span class="mobile-order-native-value">{{ order.id }}</span>
                </div>
                <div class="mobile-order-native-line">
                  <span class="mobile-order-native-label">Teslimat</span>
                  <span class="mobile-order-native-value">{{ order.deliveryDateString }}</span>
                </div>
              </div>
              <div>
                <vs-row vs-align="flex-end">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi hazırlanıyora geri çek" type="gradient" color="warning" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(order.id, null, 1)"></vs-button>
                  </vs-col>
                </vs-row>
              </div>
            </template>
            <template v-else-if="col.status === -1">
              <div @click="showPopupDetail(order)" slot="header">
                <vs-row vs-align="flex-start">
                  <vs-col vs-justify="center" vs-align="center" vs-w="5">Id</vs-col>
                  <vs-col vs-justify="center" vs-align="center" vs-w="4">Teslimat</vs-col>
                  <vs-col vs-justify="center" vs-align="center" vs-w="3">Durum</vs-col>
                </vs-row>
                <vs-row vs-align="flex-start">
                  <vs-col vs-w="5"><h3>{{ order.id }}</h3></vs-col>
                  <vs-col vs-w="4"><h3>{{order.deliveryDateString}}</h3></vs-col>
                  <vs-col vs-w="3"><h3 style="color: red;">İptal</h3></vs-col>
                </vs-row>
              </div>
              <div>
                <vs-row vs-align="flex-end">
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                    <vs-button size="large" full-width title="Siparişi görüntüle" type="gradient" color="primary" icon-pack="feather" icon="icon-eye" @click="showPopupDetail(order)"></vs-button>
                  </vs-col>
                </vs-row>
              </div>
            </template>
          </vs-card>
          <p v-if="col.orders.length === 0" class="mobile-order-accordion-empty">Sipariş yok</p>
        </div>
      </vs-collapse-item>
    </vs-collapse>

      <!-- Confirmation Popup -->
      <div fullscreen style="z-index: 9999999;" class="popup-overlay" v-if="showPopupFlag">
        <div fullscreen class="popup">
          <h3>İşlemi yapmak istediğinize eminmisiniz ?</h3>
          <p>Sipariş ID: {{ selectedOrder.integrationOrderId || selectedOrder.id }}</p>

          <div class="cancel-reason-field" v-if="selectedStatus === -1 && selectedOrder.isIntegrationOrder">
            <label for="cancelReason">İptal Sebebi Seçiniz:</label>
            <select
              id="cancelReason"
              v-model="cancelReasonString"
              required
            >
              <option value="" disabled selected>Bir sebep seçiniz</option>
              <option v-for="reason in cancelReasons" :key="reason.value" :value="reason">
                {{ reason.label }}
              </option>
            </select>
          </div>
          <div class="cancel-reason-field" v-else-if="selectedStatus === -1">
            <label for="cancelReasonText">İptal Sebebi:</label>
            <textarea
              id="cancelReasonText"
              v-model="cancelReasonText"
              rows="3"
              placeholder="İptal sebebini yazınız"
              required
            ></textarea>
          </div>

          <div class="popup-actions">
            <button
              class="btn btn-primary"
              @click="confirmPopup"
            >Tamam</button>
            <button class="btn btn-secondary" @click="closePopup">Vazgeç</button>
          </div>
        </div>
      </div>

      <!-- Order Details Popup -->
      <div style="z-index: 999;position: fixed; top: 0; left: 0; right: 0; bottom: 0;" class="popup-overlay" v-if="showPopupDetailFlag">
        <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; overflow-y: auto;" class="popup">
          <h3>{{ orderDetail.isIntegrationOrder ? 'Sipariş Detayı' : (orderDetail.id + ' No lu Sipariş Detayı') }}</h3>
          <p>Açıklama: {{ orderDetail.description }}</p>
          <div v-if="orderDetail.orderStatus === -1" class="cancel-info-box">
            <p><strong>İptal Sebebi:</strong> {{ orderDetail.cancelReason || '-' }}</p>
            <p><strong>İptal Eden:</strong> {{ orderDetail.canceledByUserName || '-' }}</p>
            <p><strong>İptal Tarihi:</strong> {{ orderDetail.canceledDate ? new Date(orderDetail.canceledDate).toLocaleString('tr-TR') : '-' }}</p>
          </div>
          <table class="ana">
            <tr>
              <td>
                <table>
                  <thead>
                    <td>Ürün</td>
                    <td>Miktar</td>
                    <td>Reçete</td>
                    <td>Ekstralar</td>
                  </thead>
                  <tbody>
                    <tr v-for="entry in orderDetail.cartEntries" :key="entry.id">
                      <td>{{ entry.productName }}</td>
                      <td>x{{ entry.quantity }}</td>
                      <td>{{ entry.description }}</td>
                      <td>
                        <table>
                          <tr v-for="extra in groupExtras(entry.extras)" :key="index" v-if="extra.quantity > 0">
                            <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;+ {{ extra.name }}</td>
                            <td>x{{ extra.quantity }}</td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </table>

          <!-- Integration Order Additional Details -->
          <div v-if="orderDetail.isIntegrationOrder" class="row">
            <div class="col-6">
              <p v-if="orderDetail.paymentInformations && orderDetail.paymentInformations.length > 0" style="margin: 10px 0">
                <strong>Ödeme Yöntemi:</strong>
                <span>{{ orderDetail.paymentInformations[0].paymentMethod.name }}</span>
              </p>
              <p><strong>Adres:</strong> {{ orderDetail.deliveryModel.address }}</p>
              <p><strong>Apartman No:</strong> {{ orderDetail.deliveryModel.apartmentNumber }}</p>
              <p><strong>Kat:</strong> {{ orderDetail.deliveryModel.floor }}</p>
              <p><strong>Kapı No:</strong> {{ orderDetail.deliveryModel.doorNo }}</p>
              <p><strong>Şehir:</strong> {{ orderDetail.deliveryModel.city }}</p>
              <p><strong>İlçe:</strong> {{ orderDetail.deliveryModel.district }}</p>
              <p><strong>Açıklama:</strong> {{ orderDetail.deliveryModel.description }}</p>
              <p><strong>Telefon:</strong> {{ orderDetail.deliveryModel.phoneNumber }}</p>
              <p><strong>Kapı Çalınmasın:</strong> {{ orderDetail.deliveryModel.doNotKnockDoor ? "Evet" : "Hayır" }}</p>
              <p><strong>Kapıya Bırak:</strong> {{ orderDetail.deliveryModel.dropOffAtDoor ? "Evet" : "Hayır" }}</p>
              <p><strong>Doğrulama Kodu:</strong> {{ orderDetail.confirmationNumber }}</p>
            </div>
            <div class="col-6">
              <p>Toplam Tutar: {{ orderDetail.totalPrice }}</p>
              <p>Toplam İndirim: {{ orderDetail.totalCampaignDiscountAmount }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-8">
              <button class="btn btn-warning" @click="closePopup">Kapat</button>
              <button class="btn btn-warning" @click="printing">Yazdır</button>
            </div>
            <div class="col-1" v-if="!orderDetail.isIntegrationOrder">
              <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-chevrons-left" @click="showPopup(orderDetail.id, null, orderDetail.orderStatus - 1)"></vs-button>
            </div>
            <div class="col-1" v-if="!orderDetail.isIntegrationOrder">
              <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-chevrons-right" @click="showPopup(orderDetail.id, null, orderDetail.orderStatus + 1)"></vs-button>
            </div>
          </div>
        </div>
      </div>

      <!-- QR Reader Popup -->
      <div class="popup-overlay" v-if="showQrReader">
        <div class="popup">
          <h3>Qr Kodu Tarayabilirsiniz</h3>
          <p>Sipariş ID: </p>
          <vs-row>
            <vs-col vs-w="3"></vs-col>
            <vs-col vs-type="center" vs-w="6" class="p-2">
              <div class="w-full text-center img-border p-5">
                <img src="@/assets/general/qr-code-scan.svg" class="w-full">
              </div>
            </vs-col>
            <vs-col vs-w="3"></vs-col>
          </vs-row>

          <vs-row vs-type="flex" vs-w="12">
            <input autocomplete="off" id="qrCode" name="Qr Kod" ref="qrInput" placeholder="Qr Kod"
              maxlength="10"
              class="w-full text-dark weight-600 text-small border-all border-grey low-border-radius px-2" 
              v-model="displayVal" @input="handleInput" />
            <span class="text-danger text-xsmaller" v-show="errors.has('Qr Kod')">{{ errors.first("Qr Kod") }}</span>
          </vs-row>

          <button class="btn btn-secondary" @click="closeQrReader">İptal</button>

          <div v-if="qrCodeOrderData!=null">
            <table>
              <thead>
                <tr>
                  <th>Sipariş ID</th>
                  <th>Sipariş İçeriği</th>
                  <th>Sipariş Saati</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ qrCodeOrderData.id }}</td>
                  <td>
                    <table>
                      <thead>
                        <tr>
                          <th>Ürün</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="product in qrCodeOrderData.cartEntries">
                          <th>{{ product.productName }}</th>
                          <th></th>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td>{{qrCodeOrderData.deliveryDateString}}</td>
                  <td>
                    <button class="btn btn-success" @click="showPopup(qrCodeOrderData.id, null, 3)">Teslim Et</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
   </vs-popup>
</template>

<style scoped lang="scss">
.mobile-order-toolbar--mobile {
  .mobile-order-toolbar-btn-wrap {
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .mobile-order-toolbar-btn {
    width: 100%;
  }
}

.mobile-order-accordion {
  margin-top: 0.75rem;
}

.mobile-order-accordion-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
}

.mobile-order-accordion-title {
  font-weight: 700;
  font-size: 1rem;
}

.mobile-order-accordion-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.75rem;
  height: 1.75rem;
  padding: 0 0.35rem;
  border-radius: 9999px;
  background: rgba(106, 31, 19, 0.12);
  color: #6a1f13;
  font-weight: 700;
  font-size: 0.9rem;
}

.mobile-order-accordion-body {
  max-height: min(60vh, 480px);
  overflow-y: auto;
  padding-top: 0.5rem;
}

.mobile-order-accordion-card {
  margin-bottom: 0.75rem;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.mobile-order-accordion-empty {
  margin: 0;
  padding: 0.75rem 0.25rem;
  color: #888;
  font-size: 0.9rem;
  text-align: center;
}

.kanban-board {
    display: flex;
    justify-content: space-between;
  }

  .kanban-column {
    flex: 1;
    margin: 0 10px;
    border-right: 1px solid #ccc;
  }

  .kanban-column-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 8px;

    h1 {
      margin: 0;
      font-size: 1.1rem;
    }
  }

  .mobile-order-bulk-dismiss-wrap {
    padding: 0 0 10px 0;
  }

  .mobile-order-bulk-dismiss-btn {
    width: 100%;
  }

  .mobile-order-native-completed-summary {
    padding: 8px 4px 4px;
  }

  .mobile-order-native-line {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    padding: 4px 0;
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none;
    }
  }

  .mobile-order-native-label {
    font-size: 0.8rem;
    color: #666;
    flex-shrink: 0;
  }

  .mobile-order-native-value {
    font-size: 1rem;
    font-weight: 600;
    text-align: right;
    word-break: break-word;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }

  th, td {
    padding: 10px;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  th {
    background-color: #f2f2f2;
  }

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    margin-right: 5px;
  }

  .btn-primary {
    background-color: #3399ff;
    color: #fff;
  }

  .btn-success {
    background-color: #00cc66;
    color: #fff;
  }

  .btn-warning {
    background-color: #ffcc00;
    color: #fff;
  }
  .btn-danger {
    background-color: #ff1500;
    color: #fff;
  }
  .btn-secondary {
    background-color: #e0e0e0;
    color: #333;
  }
  .btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  .popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .popup {
    background-color: #fff;
    padding: 24px;
    border-radius: 8px;
    width: 400px;
    text-align: center;
  }

  .popup h3 {
    margin-bottom: 8px;
  }

  .popup .cancel-reason-field {
    text-align: left;
    margin: 16px 0;
  }

  .popup .cancel-reason-field label {
    display: block;
    margin-bottom: 6px;
    font-weight: 600;
  }

  .popup .cancel-reason-field select,
  .popup .cancel-reason-field textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    resize: vertical;
  }

  .cancel-info-box {
    text-align: left;
    background-color: #fdecea;
    border: 1px solid #f5c6cb;
    border-radius: 6px;
    padding: 10px 14px;
    margin: 10px 0;
  }

  .cancel-info-box p {
    margin: 4px 0;
  }

  .popup-actions {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .popup button {
    margin-top: 0;
  }

  .warning {
  animation: blinker 1s linear infinite;
  color: red;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
  </style>

  <script>
  import {
    mobileOrder,
    mobileOrderChangeStatus,
    qrCodeRead
  } from "@/api/SelfService.js";
  import {
    getOrders,
    changeOrderStatus,
    getCancelReasons,
    dismissIntegrationOrderFromSelfServiceBoard,
    dismissAllCompletedFromSelfServiceBoard,
  } from "@/api/Integration.js";
  import {
    logSelfServiceManualEvent,
    SelfServiceEventType
  } from "@/utils/selfServiceSessionTelemetry";
  import Printer from "./Printer.vue"
  import MobileOrderCard from "./MobileOrderCard.vue";
  import signalRService from "@/SignalRService";

  export default {
    props: {
      orderListIsActive: {
        type: Boolean,
        required: true
      },

    },
    components: {
      Printer,
      MobileOrderCard
    },
    inject: ['refreshOrderQuantity'],
    data() {
      return {
        orders:[],
        showPopupFlag: false,
        showPopupDetailFlag: false,
        selectedOrder: null,
        selectedStatus: '',
        changeStatusOrder:{
          orderId:null,
          orderStatus:null,
          integrationOrderId: null,
          status: null,
          cancelNote: null,
          cancelReason: null
        },
        showQrReader:false,
        qrCode: '',
        displayVal: '',
        actualVal: '',
        maskTimeout: null,
        qrCodeOrderData:null,
        orderDetail:null,
        printeractive:false,
        currentDate :'',
        cancelReasons: [],
        cancelReasonString: null,
        cancelReasonText: '',
        isMobileOrderUi: false,
      }
    },
    beforeDestroy() {
      if (this._mobileOrderUiMq && this.updateMobileOrderUi) {
        if (this._mobileOrderUiMq.removeEventListener) {
          this._mobileOrderUiMq.removeEventListener("change", this.updateMobileOrderUi);
        } else if (this._mobileOrderUiMq.removeListener) {
          this._mobileOrderUiMq.removeListener(this.updateMobileOrderUi);
        }
      }
    },
    mounted: function () {
      this._mobileOrderUiMq = window.matchMedia("(max-width: 767px)");
      this.updateMobileOrderUi = () => {
        this.isMobileOrderUi = this._mobileOrderUiMq.matches;
      };
      this.updateMobileOrderUi();
      if (this._mobileOrderUiMq.addEventListener) {
        this._mobileOrderUiMq.addEventListener("change", this.updateMobileOrderUi);
      } else if (this._mobileOrderUiMq.addListener) {
        this._mobileOrderUiMq.addListener(this.updateMobileOrderUi);
      }
      // SelfService.vue'dan SignalR bağlantısını kullanacağız
      // Farklı bir bağlantı oluşturmaya gerek yok

      setInterval(() => {
        const activeOrders = this.orders.filter(
          (f) => f.orderStatus != 3 && f.orderStatus != -1
        );
        if (activeOrders.length === 0) return;

        this.orders
          .filter((f) => f.orderStatus != 3 && f.orderStatus != -1)
          .forEach((order) => {
            if (order.deliveryDateString == null) {
              order.deliveryDateString = "00:00";
            }
            order.tableId = this.calculateRemainingSeconds(
              parseInt(order.deliveryDateString.split(":")[0]),
              parseInt(order.deliveryDateString.split(":")[1]),
              order.deliveryDate
            );
          });
      }, 1000);

      setInterval(() => {
        this.orders.forEach(order => {
          order.tableId -= 1;
        });
      }, 1000);
    },
    computed: {
      orderListIsActiveLocal: {
        get() {
          return this.orderListIsActive;
        },
        set(val) {
          if (!val) {
            this.$emit("close");
          }
        }
      },
      orderBoardColumns() {
        const defs = [
          { status: 0, title: "Bekliyor", integrationNextTitle: "Siparişi hazırlanıyora çek", integrationNextStatus: 1 },
          { status: 1, title: "Hazırlanıyor", integrationNextTitle: "Siparişi hazırlandıya çek", integrationNextStatus: 2 },
          { status: 2, title: "Hazır", integrationNextTitle: "Siparişi Kuryeye Teslim Et", integrationNextStatus: 4 },
          { status: 4, title: "Kuryede", integrationNextTitle: "Siparişi Teslim Et", integrationNextStatus: 3 },
          { status: 3, title: "Tamamlandı", integrationNextTitle: null, integrationNextStatus: null },
          { status: -1, title: "İptal Edildi", integrationNextTitle: null, integrationNextStatus: null },
        ];
        return defs.map((d) => ({
          ...d,
          orders: this.orders.filter((o) => o.orderStatus === d.status),
        }));
      },
      completedIntegrationOrdersCount() {
        return this.orders.filter((o) => o.isIntegrationOrder && o.orderStatus === 3).length;
      },
    },
    methods: {
      handleInput(e) {
        const val = e.target.value;
        const diff = val.length - this.actualVal.length;
        if (diff < 0) {
          this.actualVal = this.actualVal.substring(0, val.length);
        } else if (diff > 0) {
          const added = val.substring(val.length - diff);
          this.actualVal += added;
        }
        
        if (this.actualVal.length > 0) {
          const lastChar = this.actualVal.charAt(this.actualVal.length - 1);
          this.displayVal = "*".repeat(this.actualVal.length - 1) + lastChar;
        } else {
          this.displayVal = "";
        }
        
        this.qrCode = this.actualVal;
        
        if (this.maskTimeout) clearTimeout(this.maskTimeout);
        this.maskTimeout = setTimeout(() => {
          this.displayVal = "*".repeat(this.actualVal.length);
        }, 400);
      },
      calculateRemainingSeconds(hour, minute,deliveryDate) {
      const now = new Date();
      if (now>new Date(deliveryDate)) {
        return -999
      }
      const target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minute, 0);
      const diff = target - now;
      const tableId = Math.floor(diff / 1000);
      return tableId;
    },
    remainingTime(tableId) {
      if (tableId <= 0) {
        return "Geçti";
      }
      tableId %= 3600;
      const remainingMinutes = Math.floor(tableId / 60);
      tableId %= 60;
      return `${remainingMinutes}:${tableId}`;
    },
      groupExtras(extras) {
      if (!extras) return [];
      const result = {}
      extras.forEach(extra => {
        if (extra.variants!=null&&extra.variants.length>0) {
          extra.variants.forEach(variant=>{
            if (!result[variant.name]) {
          result[variant.name] = {
            name: variant.name,
            quantity: 0
          }
        }
        result[variant.name].quantity += variant.quantity
          })
        }else{
          if (!result[extra.name]) {
          result[extra.name] = {
            name: extra.name,
            quantity: 0
          }
        }
        result[extra.name].quantity += extra.quantity
        }

      })
      return Object.values(result)
    },
      initValues() {
        this.qrCode = "";
      },
      showPopup(orderId, integrationOrderId, status) {
        if (orderId == null || orderId == 0) {
          this.selectedOrder = this.orders.find(
            (order) => order.integrationOrderId === integrationOrderId
          );
        } else {
          this.selectedOrder = this.orders.find((order) => order.id === orderId);
        }

        if (status == -1 && this.selectedOrder.isIntegrationOrder) {
          getCancelReasons(integrationOrderId)
            .then((response) => {
              this.cancelReasons = Object.entries(response.data).map(
                ([key, value]) => ({
                  label: value,
                  value: key,
                })
              );
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Hata",
                text: error.response.data.Errors[0].Message,
              });
            });
        }
        this.selectedStatus = status;
        this.showPopupFlag = true;
      },
      showPopupDetail2(orderId, integrationOrderId) {
        let order = this.orders.find((o) => o.id === orderId);
        if (orderId == null || orderId == 0) {
          order = this.orders.find(
            (order) => order.integrationOrderId === integrationOrderId
          );
        }

        let i = 0;
        order.cartEntries.forEach((element) => {
          element.id = i.toString();
          i++;
        });

        this.showPopupDetailFlag = true;
        this.printeractive = true;
        this.orderDetail = order;
      },
      showPopupDetail(order) {
        this.showPopupDetailFlag = true;
        this.orderDetail = order;
        this.printeractive=true
      },
      readQr(){
        this.showQrReader=true;
        this.$nextTick(() => {
        this.$refs.qrInput.focus();
      });
      },
      closePopup() {
        this.printeractive = false;
        this.showPopupFlag = false;
        this.showPopupDetailFlag = false;
        this.cancelReasonString = null;
        this.cancelReasonText = '';
      },
      printing(){
        this.getFullTime();
        this.$refs.printer.printOrders();
      },
      closeQrReader() {
        this.showQrReader = false;
        this.initValues();
      },
      confirmPopup() {
        if (this.selectedStatus === -1 && !this.selectedOrder.isIntegrationOrder && !this.cancelReasonText.trim()) {
          this.$vs.notify({
            color: "danger",
            title: "Sebep Gerekli",
            text: "İptal sebebi yazmadan devam edemezsiniz.",
          });
          return;
        }
        if (this.selectedStatus === -1 && this.selectedOrder.isIntegrationOrder && !this.cancelReasonString) {
          this.$vs.notify({
            color: "danger",
            title: "Sebep Gerekli",
            text: "Lütfen bir iptal sebebi seçiniz.",
          });
          return;
        }
        this.moveOrder(this.selectedOrder.id, this.selectedOrder.integrationOrderId, this.selectedStatus);
      },
      moveOrder(orderId, integrationOrderId, status) {
        let orderIndex = 0;
        if (orderId == null || orderId == 0) {
          orderIndex = this.orders.findIndex(
            (order) => order.integrationOrderId === integrationOrderId
          );
        } else {
          orderIndex = this.orders.findIndex((order) => order.id === orderId);
        }

        this.changeStatusOrder.orderId = this.selectedOrder.id;
        this.changeStatusOrder.orderStatus = status;

        if (this.selectedOrder.isIntegrationOrder) {
          this.changeStatusOrder.integrationOrderId = this.selectedOrder.integrationOrderId;
          this.changeStatusOrder.status = status;
          if (status == -1) {
            this.changeStatusOrder.cancelNote = this.cancelReasonString.label;
            this.changeStatusOrder.cancelReason = this.cancelReasonString.value;
          }

          changeOrderStatus(this.changeStatusOrder)
            .then((response) => {
              if (!response.data) {
                this.$vs.notify({
                  color: "danger",
                  title: "Başarısız",
                  text: "Sipariş durumu değiştirilemedi",
                });
                return;
              }
              this.getOrder();

              this.orders[orderIndex].orderStatus = status;
              if (status == -1 || status == 3) {
                try {
                  this.refreshOrderQuantity();
                } catch (error) {
                  console.error("Error calling refreshOrderQuantity:", error);
                }
                this.$emit("emitRefresh");
              }
              if (status == 3) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı",
                  text: "Sipariş teslim edildi",
                });
              }
              if (status == -1) {
                logSelfServiceManualEvent(SelfServiceEventType.IntegrationOrderCancelled, {
                  orderId: this.selectedOrder && this.selectedOrder.id,
                  integrationOrderId: this.selectedOrder && this.selectedOrder.integrationOrderId,
                  cancelReason: this.changeStatusOrder.cancelReason,
                  cancelNote: this.changeStatusOrder.cancelNote
                });
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı",
                  text: "Sipariş iptal edildi",
                });
              }
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Başarısız",
                text: error.response.data.Errors[0].Message,
              });
            });
        } else {
          if (status === -1) {
            if (!this.cancelReasonText || !this.cancelReasonText.trim()) {
              this.$vs.notify({
                color: "danger",
                title: "Hata",
                text: "İptal sebebi girmeden sipariş iptal edilemez.",
              });
              return;
            }
            this.changeStatusOrder.cancelReason = this.cancelReasonText.trim();
            const activePersonal = this.$store.getters["selfservice/getActivePersonal"];
            this.changeStatusOrder.activePersonalUserId = activePersonal ? activePersonal.id : null;
          }
          mobileOrderChangeStatus(this.changeStatusOrder)
            .then(() => {
              this.orders[orderIndex].orderStatus = status;
              if (status == -1 || status == 3) {
                try {
                  this.refreshOrderQuantity();
                } catch (error) {
                  console.error("Error calling refreshOrderQuantity:", error);
                }
                this.$emit("emitRefresh");
              }
              if (status == 3) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı",
                  text: "Sipariş teslim edildi",
                });
              }
              if (status == -1) {
                logSelfServiceManualEvent(SelfServiceEventType.MobileOrderCancelled, {
                  orderId: this.selectedOrder && this.selectedOrder.id,
                  cancelReason: this.changeStatusOrder.cancelReason
                });
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı",
                  text: "Sipariş iptal edildi",
                });
              }
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Başarısız",
                text: error.response.data.Errors[0].Message,
              });
            });
        }

        this.qrCodeOrderData = null;
        this.qrCode = "";
        this.showQrReader = false;
        this.initValues();
        this.closePopup();
      },
      getOrder: async function() {
        try {
          // Get both mobile orders and integration orders
          const [mobileOrders, integrationOrders] = await Promise.all([
            mobileOrder().catch(() => []), // Fallback to empty array if mobile orders fail
            getOrders({ excludeDismissedFromSelfServiceBoard: true }).then(response => response.data).catch(() => []) // Fallback to empty array if integration orders fail
          ]);

          // Mark mobile orders
          const markedMobileOrders = mobileOrders.map(order => ({
            ...order,
            isIntegrationOrder: false
          }));

          // Mark integration orders
          const markedIntegrationOrders = integrationOrders.map(order => ({
            ...order,
            isIntegrationOrder: true
          }));

          // Combine both arrays
          this.orders = [...markedMobileOrders, ...markedIntegrationOrders];

          // Sort by delivery date
          this.orders.sort(function(a, b) {
            return new Date(a.deliveryDate) - new Date(b.deliveryDate);
          });
        } catch (error) {
          console.error('Error fetching orders:', error);
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: "Siparişler yüklenirken hata oluştu",
          });
        }
      },
      getFullTime(){
        const date = new Date();
        const options = {
        timeZone: 'Europe/Istanbul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    };
    this.currentDate = date.toLocaleString('tr-TR', options);
      },
      qrCodeReadFunc: async function(val){
        try {
        var qrresult = await qrCodeRead(val);
          if (qrresult.result==false) {
            this.$fire({
              title: "Bulunamadı ! ",
              text: qrresult.errors[0].message,
              type: "error"
            });
          }else{
            this.qrCodeOrderData= qrresult.data;
          }
        } catch(e){
          this.$fire({
          title: "Hata !",
          text: e.message,
          type: "error"
        })
        }
      },
      closeOrderList() {
        this.orderListIsActiveLocal = false;
      },
      getOrderKey(order) {
        if (order.isIntegrationOrder) {
          return order.integrationOrderId;
        }
        return order.id;
      },
      integrationCompletedCountForColumn(col) {
        if (col.status !== 3) return 0;
        return col.orders.filter((o) => o.isIntegrationOrder).length;
      },
      onDismissIntegrationOrderFromBoardRequest(integrationOrderId) {
        if (!integrationOrderId) return;
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "Panodan kaldır",
          text: "Bu siparişi mobil sipariş panosundan kaldırmak istediğinize emin misiniz?",
          acceptText: "Kaldır",
          cancelText: "Vazgeç",
          accept: () => this.executeDismissIntegrationOrder(integrationOrderId),
        });
      },
      executeDismissIntegrationOrder(integrationOrderId) {
        dismissIntegrationOrderFromSelfServiceBoard(integrationOrderId)
          .then(() => {
            this.$vs.notify({
              color: "success",
              title: "Tamam",
              text: "Sipariş panodan kaldırıldı",
            });
            this.getOrder();
          })
          .catch((error) => {
            let text = "İşlem başarısız";
            if (error.response) {
              if (error.response.status === 404) {
                text = "Sipariş bulunamadı veya kaldırılamadı";
              } else if (error.response.data && error.response.data.Errors && error.response.data.Errors[0]) {
                text = error.response.data.Errors[0].Message;
              } else if (error.response.data && error.response.data.message) {
                text = error.response.data.message;
              }
            }
            this.$vs.notify({ color: "danger", title: "Hata", text });
          });
      },
      onDismissAllCompletedIntegrationRequest() {
        this.$vs.dialog({
          type: "confirm",
          color: "warning",
          title: "Toplu temizle",
          text:
            "Şubedeki tüm tamamlanan entegrasyon siparişlerini panodan kaldırmak istediğinize emin misiniz?",
          acceptText: "Evet, tümünü kaldır",
          cancelText: "Vazgeç",
          accept: () => {
            dismissAllCompletedFromSelfServiceBoard()
              .then((res) => {
                const n =
                  res.data && res.data.dismissedCount != null
                    ? res.data.dismissedCount
                    : 0;
                this.$vs.notify({
                  color: "success",
                  title: "Tamam",
                  text: `${n} sipariş panodan kaldırıldı`,
                });
                this.getOrder();
              })
              .catch((error) => {
                let text = "İşlem başarısız";
                if (
                  error.response &&
                  error.response.data &&
                  error.response.data.Errors &&
                  error.response.data.Errors[0]
                ) {
                  text = error.response.data.Errors[0].Message;
                }
                this.$vs.notify({ color: "danger", title: "Hata", text });
              });
          },
        });
      },
    },
    created: async function () {
      // Load both mobile and integration orders
      await this.getOrder();

      // Listen for both mobile and integration SignalR events
      signalRService.on("can-not-integrated-order", (message) => {
        let messageText = "Siparişi alınamadı";
        if (message == 0) {
          messageText = "Getir " + messageText;
        } else if (message == 1) {
          messageText = "Trendyol Go " + messageText;
        } else if (message == 2) {
          messageText = "Yemeksepeti " + messageText;
        }

        this.$vs.notify({
          color: "danger",
          title: "Sipariş alınamadı",
          text: messageText,
        });
      });

      signalRService.on("SendOrder", (message) => {
        console.log('Got new order:', message);
        this.getOrder(); // Refresh all orders
      });

      this.$once('hook:beforeDestroy', () => {
        signalRService.off("can-not-integrated-order");
        signalRService.off("SendOrder");
      });
    },
    watch: {
      qrCode(val) {
        if (!val) {
          this.actualVal = "";
          this.displayVal = "";
        }
        this.qrCodeOrderData=null;
        if (val && val.length == 10){
         this.qrCodeReadFunc(val);
        }
      }
    }
  }
  </script>
